<script lang="ts">
  import { page } from "$app/stores";
	import { LinkAction } from "$lib/components/atoms/Link";
	import { Prose } from "$lib/components/atoms/Prose";
	import { useCTAFlow } from "$lib/utils/cta-flow";
	import { ctaRequestBuilders } from "$lib/utils/cta-flow/helpers";
	import { ArticleCard, CourseCard, CourseCardWide, EventCard } from "$lib/components/organisms/Card";
  import spinner from "$lib/assets/animated/spinner.svg";
	import { SectionCarousel, SectionCarouselIndicators } from "$lib/components/organisms/SectionCarousel";
	import { Section } from "$lib/components/organisms/Section";
	import { ScrollableCardWrapper, ScrollableComponentWrapper } from "$lib/components/organisms/Layout";
	import { Button } from "$lib/components/atoms/Button";
	import { B2B_FONDO_NUOVE_COMPETENZE } from "$lib/utils/custom-courses";
	import type { Powertag } from "$lib/utils/powertags/types";

  export let powertags: Powertag[] = [];

  export let prose: boolean = false;

  const ctaFlow = useCTAFlow();

  let loading = false;
</script>

<div class="powertag-component">
  {#each powertags as tag, index (index)}
    {#if tag.type === 'Text' && tag.element !== ''}
      {#if prose}
        <Prose fullWidth>
          {@html tag.element.replace(/[^\\\n]+/g, (value, p1, p2) => {
            return '<div>' + value + '</div>';
          })}
        </Prose>
      {:else}
        {@html tag.element
          .replace(/[^\\\n]+/g, (value, p1, p2) => {
            return '<div>' + value + '</div>';
          })
          .replace(/(?:\r\n|\r|\n)/g, '<br/>')}
      {/if}
    {:else}
      {#if tag.title}
        <h2 class="fs-3 mb-2">{tag.title}</h2>
      {/if}

      {#if tag.type === 'ProductCard'}
        <section class=" powertag product-card">
          <CourseCard lazyLoad={true} course={tag.element} />
        </section>
      {:else if tag.type === 'ProductWideCard'}
        <section class=" powertag product-wide-card">
          <CourseCardWide lazyLoad={true} link course={tag.element} isPowertag>
            <svelte:fragment slot="footer">
              {#if tag.download}
                <LinkAction
                  icon={(!loading && 'chevronRight') || ''}
                  class="m-auto xs:m-0"
                  on:click={() => {
                    loading = true;
                    ctaFlow.startCTAFlow($page.url.pathname, 'downloadBrochure', ctaRequestBuilders.downloadBrochure(tag.element.sessions[tag.element.idMainSession], $page)).finally(() => {
                      setTimeout(() => (loading = false), 2000);
                    });
                  }}
                >
                  {#if loading}
                    <img src={spinner} width="20" height="20" />
                  {:else}
                    Download brochure
                  {/if}
                </LinkAction>
              {/if}
            </svelte:fragment>
          </CourseCardWide>
        </section>
      {:else if tag.type === 'NewsCard'}
        <section class="powertag news-card">
          <ArticleCard lazyLoad={true} article={tag.element} />
        </section>
      {:else if tag.type === 'EventCard'}
        <section class="powertag event-card">
          <EventCard lazyLoad={true} event={tag.element} />
        </section>
      {:else if tag.type === 'ProductSlide' && tag.element && tag.element.length > 0}
        <section class="powertag product-slide">
          <SectionCarousel mobileCount={0} desktopCount={3} desktopBreakpoint="lg" id="section-carousel-{tag.id}">
            <Section>
              <svelte:fragment slot="indicators">
                <SectionCarouselIndicators id="section-carousel-{tag.id}" />
              </svelte:fragment>

              <ScrollableCardWrapper lazyLoad={true} courses={tag.element} sectionCarouselId="section-carousel-{tag.id}" />
            </Section>
          </SectionCarousel>
        </section>
      {:else if tag.type === 'EventSlide' && tag.element && tag.element.length > 0}
        <section class="powertag event-slide">
          <SectionCarousel mobileCount={0} desktopCount={3} desktopBreakpoint="lg" id="section-carousel-events-{tag.id}">
            <Section>
              <ScrollableComponentWrapper sectionCarouselId="section-carousel-events-{tag.id}">
                <svelte:fragment slot="indicators">
                  <SectionCarouselIndicators id="section-carousel-events-{tag.id}" />
                </svelte:fragment>
                <svelte:fragment slot="components">
                  {#each tag.element as event}
                    <EventCard lazyLoad={true} {event} />
                  {/each}
                </svelte:fragment>
              </ScrollableComponentWrapper>
            </Section>
          </SectionCarousel>
        </section>
      {:else if tag.type === 'NewsSlide' && tag.element && tag.element.length > 0}
        <section class="powertag news-slide">
          <SectionCarousel mobileCount={0} desktopCount={3} desktopBreakpoint="lg" id="section-carousel-news-{tag.id}">
            <Section>
              <ScrollableComponentWrapper sectionCarouselId="section-carousel-news-{tag.id}">
                <svelte:fragment slot="indicators">
                  <SectionCarouselIndicators id="section-carousel-news-{tag.id}" />
                </svelte:fragment>
                <svelte:fragment slot="components">
                  {#each tag.element as article}
                    <ArticleCard lazyLoad={true} {article} />
                  {/each}
                </svelte:fragment>
              </ScrollableComponentWrapper>
            </Section>
          </SectionCarousel>
        </section>
      {:else if tag.type === 'B2BDownload'}
        <section class="powertag b2b-download text-center">
          <Button
            disabled={loading}
            isLoading={loading}
            on:click={() => {
              loading = true;
              const ctaFlow = useCTAFlow();
              ctaFlow.startCTAFlow(
                $page.url.pathname,
                'downloadBrochure',
                ctaRequestBuilders.downloadBrochure(tag.element.sessions[tag.element.idMainSession], $page, {
                  b2b: true,
                }),
                null,
                B2B_FONDO_NUOVE_COMPETENZE.downloadBrochureConfirmationPath
              );
            }}
            icon="download"
            color="pink">{tag.buttonText}</Button
          >
        </section>

        <!-- <Button on:click={() => console.log("b2b download cta")}>{tag.title}</Button> -->
      {:else if tag.type === 'VideoPlayer' && tag.url && tag.url.length > 0}
        <section class="powertag video-player">
          <!-- Youtube video player centered and responsive-->
          <iframe
            class="w-[100%] max-w-3xl mx-auto aspect-video"
            src={tag.url}
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            title="Youtube video player"
          ></iframe>
        </section>
      {/if}
    {/if}
  {/each}
</div>

<style type="text/scss" lang="scss" scoped>
  .aspect-video {
    aspect-ratio: 16 / 9;
  }
</style>
